
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oncology",
      function () {
        return require("private-next-pages/oncology.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oncology"])
      });
    }
  